// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getPriceTierSimpelist, getUserGroupEditDetail, userGroupEdit } from '@/services/members.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  name: 'onlineCouponEdit',
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData,
      btnTxt: this.$t('button.confirm'),
      groupTypeOptions: [
        {
          label: this.$t('form.groupUser.retail'),
          value: 'retail'
        },
        {
          label: this.$t('form.groupUser.wholesale'),
          value: 'wholesale'
        }
      ]
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getPriceTierSimpelist().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[2].options = res.data.wholesale_pricing_tiers
          if (process.env.VUE_APP_NAME.includes('wholesale')) {
            this.formData[0].createDateItem[1].options = this.groupTypeOptions.filter(option => option.value !== 'retail')
          } else {
            this.formData[0].createDateItem[1].options = this.groupTypeOptions
          }
        }
      })
      getUserGroupEditDetail(this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.modifyData = res.data.user_group
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    handleChange (data, prop) {
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        user_group: obj
      }
      userGroupEdit(this.$route.params.id, params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'userGroupList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
